import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from '@/serviceWorker';
import '@elastic/eui/dist/eui_theme_light.min.css';
import {
  EuiHeader,
  EuiSuperSelect,
  EuiPage,
  EuiHeaderLinks,
  EuiFlexGroup,
  EuiFlexItem,
  // EuiPopover,
  // EuiToolTip,
  EuiOverlayMask,
  EuiTitle,
  EuiLoadingSpinner,
} from '@elastic/eui';
import '@/layout/layout.css';
import './index.css';
import introduction_bg from '@/assets/images/index/introduction_bg.png';
import device_bg from '@/assets/images/index/device_bg.png';
import jiegou from '@/assets/images/index/jiegou.png';
import machine from '@/assets/images/index/machine.png';
import chiller from '@/assets/images/index/chiller.png';
import MTC from '@/assets/images/index/MTC.png';
import drier from '@/assets/images/index/drier.png';
import picker from '@/assets/images/index/picker.png';
// import qrcode_wx from '@/assets/images/index/wx_qrcode.jpg';
// import qrcode from '@/assets/images/qrcode.svg';
import { setCookie } from '@/websdk/utils/common';
import lang from '@/constant/lang';
import { locale } from '@/constant/locale';
import { useAllLanguages } from '@/server';
import logo from '@/assets/images/logo.png';
import qrcode_techmation from '@/assets/images/index/qrcode_techmation.png';
import { config } from '@/layout/config';
console.log(require('@/assets/css/oauth_login.css'));
serviceWorker.unregister();

function Login() {
  const [refresh, setRefresh] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [lng, setLng] = useState(lang);
  const [disabled, setDisabled] = useState(true);
  const [allLanguages, isGetSuccessed] = useAllLanguages(true, lng);
  useEffect(() => {
    if (isGetSuccessed) {
      localStorage.allLanguages = JSON.stringify(allLanguages);
      setDisabled(false);
      setIsModalVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGetSuccessed]);
  useEffect(() => {
    if (refresh) {
      setRefresh(false);
      window.location.reload();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lng]);
  localStorage.lang = lng;
  localStorage.setItem('filters', '');
  // const [isQrcodePopoverOpen, setIsQrcodePopoverOpen] = useState(false);
  // const closeQrcodePopover = () => setIsQrcodePopoverOpen(false);
  //获取图片数据
  // const [qrcode_wx2, setQrcode] = useState(null);
  // const [isFinish, setCreateQRCodeFinish] = useState(false);
  // const [isQRRequestSuccessed, qrcodeData, createQRCodePost] = useCreateQRCodePost();
  // useEffect(() => {
  //   if (isQRRequestSuccessed && !qrcodeData.errcode) {
  //     var codeImg = 'data:image/png;base64,' + qrcodeData;
  //     setQrcode(codeImg);
  //     localStorage.setItem('qrcode_wx', codeImg);
  //   }
  // }, [isQRRequestSuccessed, qrcodeData]);
  // useEffect(() => {
  //   if (!isFinish) {
  //     setCreateQRCodeFinish(true);
  //     createQRCodePost({
  //       data: { width: 240, scene: window.location.host },
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isFinish]);
  // const qrcodeButton = (
  //   <div
  //     style={{ cursor: 'pointer' }}
  //     onClick={() => {
  //       setIsQrcodePopoverOpen(isQrcodePopoverOpen => !isQrcodePopoverOpen);
  //     }}
  //   >
  //     <EuiFlexGroup alignItems="center" gutterSize="none">
  //       <EuiFlexItem grow={false}>
  //         <img src={qrcode} style={{ width: 24, height: 24 }} alt="qrcode" />
  //       </EuiFlexItem>
  //     </EuiFlexGroup>
  //   </div>
  // );

  let modalLayout;

  if (isModalVisible) {
    modalLayout = (
      <EuiOverlayMask
        onClick={() => {
          setIsModalVisible(false);
        }}
      >
        <EuiTitle>
          <h2>
            <EuiLoadingSpinner size="xl" />{' '}
          </h2>
        </EuiTitle>
      </EuiOverlayMask>
    );
  }
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {modalLayout}
      <EuiHeader
        className="iiws__header"
        sections={[
          {
            items: [<img style={{ height: '48px' }} src={logo} alt="logo" />],
            borders: 'none',
          },
          {
            items: [
              <EuiHeaderLinks gutterSize="xs" popoverBreakpoints={['xs']}>
                <div style={{ marginRight: 10, color: '#fff' }}>
                  <button
                    type="submit"
                    onClick={() => {
                      setCookie(`${config.cookie_prefix}ProcessURL`, '', '/');
                      window.location = '/login_page.html';
                    }}
                    disabled={disabled}
                  >
                    {lang ? locale[lang].DEAR : locale['zh-CN'].DEAR}
                  </button>
                </div>
                <div className="iiws__headerDivide"></div>
                <div className="iiws_langSelect">
                  <EuiSuperSelect
                    className="iiws__headerSelect"
                    options={[
                      {
                        value: 'zh-CN',
                        inputDisplay: '中文简体',
                      },
                      {
                        value: 'zh-TW',
                        inputDisplay: '中文繁体',
                      },
                      {
                        value: 'en-US',
                        inputDisplay: 'English',
                      },
                    ]}
                    valueOfSelected={lang}
                    onChange={lang => {
                      localStorage.lang = lang;
                      setCookie('lang', lang, '/');
                      setLng(lang);
                      setRefresh(true);
                    }}
                  />
                </div>
                {/* <div className="iiws__headerDivide"></div> */}
                {/* <EuiToolTip
                  className="tool-tip"
                  content={
                    isQrcodePopoverOpen
                      ? ''
                      : lang
                      ? locale[lang].WECHAT_APPLET
                      : locale['zh-CN'].WECHAT_APPLET
                  }
                >
                  <EuiPopover
                    button={qrcodeButton}
                    isOpen={isQrcodePopoverOpen}
                    closePopover={closeQrcodePopover}
                    hasArrow={false}
                  >
                    <div style={{ marginBottom: 5 }}>
                      {lang ? locale[lang].WECHAT_APPLET : locale['zh-CN'].WECHAT_APPLET}:
                    </div>
                    <div>
                      <img
                        src={qrcode_wx2 ? qrcode_wx2 : qrcode_wx}
                        alt={lang ? locale[lang].WECHAT_APPLET : locale['zh-CN'].WECHAT_APPLET}
                        width={280}
                      />
                    </div>
                  </EuiPopover>
                </EuiToolTip> */}
                <div style={{ width: 20 }}></div>
              </EuiHeaderLinks>,
            ],
            borders: 'none',
          },
        ]}
      />
      <EuiPage
        style={{
          width: '100%',
          backgroundColor: '#fff',
          padding: 0,
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          <EuiFlexGroup
            style={{
              height: 700,
              width: '100%',
              background: `url(${introduction_bg})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
              paddingTop: 112,
              paddingLeft: 280,
            }}
            gutterSize="none"
          >
            <EuiFlexItem grow={false} style={{ width: '100%', height: 514 }}>
              <EuiFlexGroup
                gutterSize="none"
                direction="column"
                style={{
                  width: 920,
                  height: 514,
                  color: '#fff',
                  justifyContent: 'space-between',
                }}
              >
                <EuiFlexItem grow={false} style={{ width: '100%' }}>
                  <div style={{ fontSize: 48, marginBottom: 37 }}>
                    <div style={{ fontWeight: 'bold' }}>Product Overview</div>
                    <div>
                      {lang ? locale[lang].PRODUCT_OVERVIEW : locale['zh-CN'].PRODUCT_OVERVIEW}
                    </div>
                  </div>
                  <p style={{ fontSize: 18, lineHeight: '31px', color: '#fff' }}>
                    {lang ? locale[lang].OVERVIEW : locale['zh-CN'].OVERVIEW}
                  </p>
                </EuiFlexItem>
                <EuiFlexItem grow={false} style={{ height: 54, width: '100%' }}>
                  <EuiFlexGroup gutterSize="none">
                    <EuiFlexItem>
                      <EuiFlexGroup gutterSize="none">
                        <EuiFlexItem>
                          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 6 }}>
                            Visualizable
                          </div>
                          <div style={{ fontSize: 16 }}>
                            {lang ? locale[lang].STANDARD : locale['zh-CN'].STANDARD}
                          </div>
                        </EuiFlexItem>
                      </EuiFlexGroup>
                    </EuiFlexItem>
                    <EuiFlexItem style={{ borderLeft: '1px solid #fff' }}>
                      <EuiFlexGroup gutterSize="none" justifyContent="center">
                        <EuiFlexItem grow={false}>
                          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 6 }}>
                            Interconnecting
                          </div>
                          <div style={{ fontSize: 16 }}>
                            {lang ? locale[lang].REAL_TIME : locale['zh-CN'].REAL_TIME}
                          </div>
                        </EuiFlexItem>
                      </EuiFlexGroup>
                    </EuiFlexItem>
                    <EuiFlexItem style={{ borderLeft: '1px solid #fff' }}>
                      <EuiFlexGroup gutterSize="none" justifyContent="center">
                        <EuiFlexItem grow={false}>
                          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 6 }}>
                            Traceable
                          </div>
                          <div style={{ fontSize: 16 }}>
                            {lang ? locale[lang].TRANSPARENCY : locale['zh-CN'].TRANSPARENCY}
                          </div>
                        </EuiFlexItem>
                      </EuiFlexGroup>
                    </EuiFlexItem>
                    <EuiFlexItem style={{ borderLeft: '1px solid #fff' }}>
                      <EuiFlexGroup gutterSize="none" justifyContent="center">
                        <EuiFlexItem grow={false}>
                          <div style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 6 }}>
                            Expandable
                          </div>
                          <div style={{ fontSize: 16 }}>
                            {lang ? locale[lang].HEALTH : locale['zh-CN'].HEALTH}
                          </div>
                        </EuiFlexItem>
                      </EuiFlexGroup>
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiFlexGroup
            alignItems="center"
            style={{
              height: 510,
              width: '100%',
              color: '#007bd8',
              background: `url(${device_bg})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
            }}
            gutterSize="none"
            justifyContent="spaceBetween"
          >
            <EuiFlexItem grow={false}>
              <img
                src={machine}
                style={{ height: 200 }}
                alt={lang ? locale[lang].IM : locale['zh-CN'].IM}
              />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <img
                src={chiller}
                style={{ height: 200 }}
                alt={lang ? locale[lang].CHILLER : locale['zh-CN'].CHILLER}
              />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <img
                src={MTC}
                style={{ height: 200 }}
                alt={lang ? locale[lang].TCU : locale['zh-CN'].TCU}
              />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <img
                src={drier}
                style={{ height: 200 }}
                alt={lang ? locale[lang].DRIER : locale['zh-CN'].DRIER}
              />
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
              <img
                src={picker}
                style={{ height: 200 }}
                alt={lang ? locale[lang].PICKER : locale['zh-CN'].PICKER}
              />
            </EuiFlexItem>
          </EuiFlexGroup>
          <EuiFlexGroup
            style={{
              height: 1035,
              width: '100%',
              background: `url(${jiegou})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '100% 100%',
            }}
            justifyContent="center"
            alignItems="center"
            direction="column"
            gutterSize="none"
          ></EuiFlexGroup>
          <EuiFlexGroup
            gutterSize="none"
            style={{
              height: 155,
              width: '100%',
              background: `#16191C`,
              padding: '0px 280px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <EuiFlexItem grow={false}>
              <EuiFlexGroup gutterSize="none">
                <EuiFlexItem grow={false}>
                  <img src={qrcode_techmation} width={81} height={81} alt="" />
                </EuiFlexItem>
                <EuiFlexItem style={{ fontSize: 16, color: '#BFBFBF', paddingLeft: 18 }}>
                  <EuiFlexGroup gutterSize="none" direction="column">
                    <EuiFlexItem>
                      {lang ? locale[lang].COMPONY : locale['zh-CN'].COMPONY}
                    </EuiFlexItem>
                    <EuiFlexItem>
                      {lang ? locale[lang].ADDRESS : locale['zh-CN'].ADDRESS}
                    </EuiFlexItem>
                    <EuiFlexItem>Sales@techmation.com.cn</EuiFlexItem>
                    <EuiFlexItem>+86-574-86987281 86987282</EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
            <EuiFlexItem grow={false} style={{ fontSize: 16, color: '#BFBFBF' }}>
              <EuiFlexGroup gutterSize="none" direction="column" style={{ height: 81 }}>
                <EuiFlexItem></EuiFlexItem>
                <EuiFlexItem></EuiFlexItem>
                <EuiFlexItem style={{ textAlign: 'end' }}>工信部备案号</EuiFlexItem>
                <EuiFlexItem style={{ textAlign: 'end' }}>浙ICP备20003786号-1</EuiFlexItem>
              </EuiFlexGroup>
            </EuiFlexItem>
          </EuiFlexGroup>
        </div>
      </EuiPage>
    </div>
  );
}

ReactDOM.render(<Login />, document.getElementById('iiws'));
